import { Box, CircularProgress } from '@mui/material';
import styled, { css } from 'styled-components';

import { getTheme } from '@commons/utils/theme';

const theme = getTheme();

// Container for progress circle (right part)
export const ProgressCircleContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Container for the relative positioning of the CircularProgress
export const ProgressCircleWrapper = styled(Box)`
  position: relative;
  display: inline-flex;
`;

// Styled CircularProgress with dynamic colors
export const StyledCircularProgress = styled(CircularProgress)`
  ${({ $isComplete, $useIsComplete }) =>
    $useIsComplete === true &&
    css`
      color: ${$isComplete ? theme.colors.brand.primary : theme.colors.greys.darkest};
    `}

  ${({ $isEqual, $useIsComplete }) =>
    $useIsComplete === false &&
    css`
      color: ${$isEqual ? theme.colors.brand.primary : theme.colors.infoRed};
    `}

  & .MuiCircularProgress-circle {
    stroke-linecap: round;
  }
`;

// Container for progress percentage text
export const ProgressPercentageContainer = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
